var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Apexcharts',{key:_vm.key,ref:"chart",attrs:{"type":_vm.type === 'bar' ? 'bar' : 'area',"options":_vm.options,"series":_vm.series,"height":_vm.height},on:{"click":function($event){return _vm.handleClick($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }